import 'utils/responsiveScreenAdapter.js';
import 'utils/mtaStatistic.js';
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store/index';
import GIcon from 'components/basic/Icon.vue';

Vue.config.productionTip = false;
Vue.component('g-icon', GIcon);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
